import {Injectable} from '@angular/core';
import {DialogHelperComponent, DialogType} from '~/app/shared/helpers/dialog-helper';

@Injectable({
    providedIn: 'root'
})
export class GlobalMessageBoxService {

    constructor(public dialogHelper: DialogHelperComponent) {
    }

    async CommonPageAlert(header: string, message: string, buttons: string[] = ['OK']) {
        await this.dialogHelper.open(
            {
                type: DialogType.INFO,
                title: header,
                content: message,
                actions: [
                    {text: 'Ok', themeColor:"primary"}
                ],
                width: 300
            });
    }

    async ErrorPageAlert(message: string) {
        await this.dialogHelper.open(
            {
                type: DialogType.ERROR,
                title: 'Error',
                content: message,
                actions: [
                    {text: 'Ok', themeColor:"primary"}
                ],
                width: 300
            });
    }
}
